import React from 'react';
import style from './index.scss';
import classnames from 'classnames';
import { TwoSliceDonutChart } from '../../../components/ns/NestPieChart';

const AverageAged = ({ data }) => {
  if (data) {
    return (
      <div
        className={classnames(style.dualCharts)}
        style={{ borderRight: 'solid 1px #e4e4e4' }}>
        <div style={{ flexDirection: 'column' }}>
          <div className={classnames(style.dualChartsTitle)}>Avg. Aged</div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <TwoSliceDonutChart data={data} text={1} dataKey="value" />
            <TwoSliceDonutChart data={data} text={30} dataKey="value" />
          </div>
          <div style={{ textAlign: 'center' }}>
            <div
              className={classnames(style.paramIndicatorList)}
              style={{ justifyContent: 'center' }}>
              <ul>
                <li>
                  <i
                    className={classnames(style.indicator)}
                    style={{ backgroundColor: '#335777' }}></i>
                  <span className={classnames(style.indicatorText)}>
                    Alerts Resolved
                  </span>
                </li>
                <li>
                  <i
                    className={classnames(style.indicator)}
                    style={{ backgroundColor: '#6bbed7' }}></i>
                  <span className={classnames(style.indicatorText)}>
                    Backlog
                  </span>
                </li>
              </ul>
            </div>
            <div className={classnames(style.dualChartsSubTitle)}>
              <p>Individual Investigation Performance</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default AverageAged;
